import * as components from '../components'
export default {
  install(Vue){
    (function registerComponents(components){
      if(components){
        for(const key in components){
          const component = components[key]
          if(component && !registerComponents(component._child_components)){
            Vue.component(key, component)
          }
        }
        return true
      }
      return false
    })(components)
  }
}